import { useEffect } from 'react';
import {
  getFaviconHref,
  setDocumentFavicon,
} from '@client/helpers/favicon.helpers';
import { getHostnameEnvironment } from '@shared/helpers/environment.helpers';
import { NodonEnvironment } from '@shared/models/environment.model';

/**
 * Set the browser favicon based on hostname (localhost / test / production).
 * Unknown hosts (e.g. a Cloudflare tunnel) keep the localhost icon so print
 * capture does not crash.
 */
export const useFavicon = (): void => {
  useEffect(() => {
    const environment =
      getHostnameEnvironment(window.location.hostname) ??
      NodonEnvironment.Localhost;
    setDocumentFavicon(getFaviconHref(environment));
  }, []);
};
